export default class SubscriberImportReportCtrl {
    constructor($scope, $state, $filter, SideMenu, Subscriber) {
        SideMenu.setActive("subscriber");

        this._scope = $scope;
        this._state = $state;
        this._filter = $filter;
        this.subscriberRepo = Subscriber;

        this.failedCurrentPage = 1;
        this.partialFailedCurrentPage = 1;

        this.subscriberRepo.getImportReport(this._state.params.id).then((report) => {
            this.report = report.data;
            this.report.failed_rows.failed = this.report.failed_rows.failed.map((column) => {
                return ({
                    ...column,
                    identifiers: column.identifiers.reduce((acc, curr) => {
                        acc[curr.field] = curr.value
                        return acc
                    }, {})
                })
            })
            this.report.failed_rows.partial_failed = this.report.failed_rows.partial_failed.map((column) => {
                return ({
                    ...column,
                    identifiers: column.identifiers.reduce((acc, curr) => {
                        acc[curr.field] = curr.value
                        return acc
                    }, {})
                })
            })
        });
    }

    loadMorePartialFailed() {
        let nextPage = ++this.partialFailedCurrentPage;
        this.subscriberRepo.getFailedRows(this._state.params.id, nextPage, true).then((response) => {
            angular.forEach(response.data, (row) => {
                this.report.failed_rows.partial_failed.push({
                    ...row,
                    identifiers: row.identifiers.reduce((acc, curr) => {
                        acc[curr.field] = curr.value
                        return acc
                    }, {})
                });
            });
        });
    };

    loadMoreFailed() {
        let nextPage = ++this.failedCurrentPage;
        this.subscriberRepo.getFailedRows(this._state.params.id, nextPage, false).then((response) => {
            angular.forEach(response.data, (row) => {
                this.report.failed_rows.failed.push({
                    ...row,
                    identifiers: row.identifiers.reduce((acc, curr) => {
                        acc[curr.field] = curr.value
                        return acc
                    }, {})
                });
            });
        });
    }
}
